/**
* @version GENERATOR_VERSION::20200408
* @DateTime 2020-04-22T09:43:56.842
* @Author <a href=\"mailto:bigmouthz@foxmail.com\">bigmouthz</a>
**/
import util from '@/libs/util';
import router from '@/router';
import {
	listHouseInfo,
	listHouseInfoInit,
	listHouseInfoByAuthorizations,
	deleteHouseInfo
	
} from '@api/lcf/HouseInfo';

import {
	cloneObj
} from '@/plugins/utils'

import RespCommonDef from '@/plugins/utils/RespCommonDef'

export default {
	namespaced: true,
	state: {	
		// 初始化信息
		CompoundEntitiesDictionary: cloneObj(RespCommonDef.CompoundEntitiesDictionary),
		//查询接口返回的数据
		CompoundEntities: cloneObj(RespCommonDef.CompoundEntities),
	    Entities:cloneObj(RespCommonDef.Entities),
		//查询条件
		AdvanceQuery:cloneObj(RespCommonDef.AdvanceQuery),
	},

	actions: {
		listHouseInfo({
			state
		}) {
			return new Promise((resolve, reject) => {
				listHouseInfo(state.AdvanceQuery)
					.then(async res => {
						state.Entities = res;
						resolve(res);
					})
					.catch(err => {
						reject(err);
					})
			})
		},

		listHouseInfoByAuthorizations({
			state
		}) {
			return new Promise((resolve, reject) => {
				listHouseInfoByAuthorizations(state.AdvanceQuery)
					.then(async res => {
						state.CompoundEntities =res
						resolve(res);
					})
					.catch(err => {
						reject(err);
					})
			})
		},

		listHouseInfoInit({
			state
		}) {
			return new Promise((resolve, reject) => {
				listHouseInfoInit(state.AdvanceQuery)
					.then(async res => {
						state.CompoundEntitiesDictionary = res;
						resolve(res);
					})
					.catch(err => {
						reject(err);
					})
			})
		},

		deleteHouseInfo({
			state
		}, {id}) {
			return new Promise((resolve, reject) => {
				deleteHouseInfo({
						id
					})
					.then(async res => {
						resolve(res);
					})
					.catch(err => {
						reject(err);
					})
			})
		},

	}
};
